<template>
  <NuxtLayout :name="layoutName" :navbar-color="layoutNavbarColor">
    <div v-if="story" :key="currentPage" class="articles">
      <section class="container">
        <BlogBreadcrumbs class="articles__breadcrumbs" />
        <StoryblokComponent :blok="story.content" />
        <div class="articles__grid">
          <BlogArticlePreview
            v-for="article in articles"
            :key="article.uuid"
            :article="article"
          />
        </div>
      </section>
      <BlogPaginationNav
        :page="currentPage"
        :total-articles="totalArticles"
        :total-pages="totalPages"
        path="blog/articles"
      />
      <section class="articles__newsletter-section">
        <div class="container">
          <BlogNewsletterCard />
        </div>
      </section>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const { story } = await useFetchStory('blog/articles')
const { getBreadcrumbsJsonLd } = useBreadcrumbs()

const { loadArticles, totalArticles, totalPages, currentPage } =
  useBlogPagination()

const articles = await loadArticles()

useCustomHead(story, {
  jsonLd: getBreadcrumbsJsonLd(),
})
false && /*#__PURE__*/ defineI18nRoute({
  locales: ['en'],
})
const { layoutName, layoutNavbarColor } = useStoryLayout<any>(story)
</script>

<style lang="scss" scoped>
.articles {
  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 56px;
    margin-bottom: 56px;

    @media (min-width: $breakpoint-md) {
      row-gap: 96px;
      column-gap: 56px;
      grid-template-columns: 1fr 1fr;
      margin-bottom: 96px;
    }
  }

  &__nav {
    margin: 120px 0;
  }

  &__load-button {
    display: block;
    margin: 0 auto 80px;

    @media (min-width: $breakpoint-md) {
      margin: 0 auto 128px;
    }
  }

  &__newsletter-section {
    background-color: var(--paper-100);
    padding: 80px 0;

    @media (min-width: $breakpoint-md) {
      padding: 128px 0;
    }
  }
}
</style>
